// Phase 7 — Track B T-B2. Cross-cutting form / button labels.
//
// Used by the form primitives (FormSubmit) and any other surface that
// needs a calm, consistent loading / save / cancel label. Not module-
// specific copy.
//
// Phrasing rules per blueprint §13.4 / §13.8 — calm, direct, sentence
// case, no exclamation marks, no emoji, no trailing punctuation in button
// labels.

export const sharedCopy = {
  save: 'Save',
  saving: 'Saving',
  cancel: 'Cancel',
  delete: 'Delete',
  deleting: 'Deleting',
  loading: 'Loading',
  edit: 'Edit',
  add: 'Add',
  retry: 'Retry',
} as const;
